import {CommonModule} from '@angular/common';
import {Component, Input, input, output} from '@angular/core';

@Component({
  selector: 'app-custom-button',
  imports: [
    CommonModule,
  ],
  templateUrl: './custom-button.component.html',
  styleUrl: './custom-button.component.scss'
})
export class CustomButtonComponent {
  text = input<string>();
  disabled = input<boolean>();
  onClick = output<void>();
  isLoading = input<boolean>();
  @Input() bgColor: string = '#3A3BE4';
  @Input() borderColor: string = 'none';
  @Input() textColor: string = '#FFFFFF';


  handleClick() {
    this.onClick.emit();
  }
}
